<template>
  <!-- Link to the sheet of a record (see detailStack.js): opens it over the
       current screen; Ctrl/Cmd/middle click opens the direct link in a tab -->
  <a :href="href" class="entity-link" @click="open"><slot /></a>
</template>

<script>
import { computed } from "vue";
import { detailLink, openDetail } from "../../detailStack";

// Page of each kind of sheet, for the direct link
const PAGES = {
  offer: "/offers",
  purchase: "/myoffers",
  item: "/items",
  sale: "/sales",
};

export default {
  name: "EntityLink",
  props: {
    type: { type: String, required: true },
    id: { type: [String, Number], required: true },
    // Sheet of the page the link is in (for "← Retour")
    from: { type: String, default: null },
    fromId: { type: [String, Number], default: null },
  },
  setup(props) {
    const href = computed(() =>
      detailLink(props.type, props.id, PAGES[props.type] || "/dashboard"),
    );
    const open = (event) => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.button)
        return;
      event.preventDefault();
      event.stopPropagation();
      openDetail(props.type, props.id, {
        from: props.from,
        fromId: props.fromId,
      });
    };
    return { href, open };
  },
};
</script>
